import React, { useState } from 'react';
import { clients } from '../../data/clients';
import { forecasts } from '../../data/forecasts';
import { MapPin, Phone, Mail, AlertCircle } from 'lucide-react';
export function ClientList() {
  const [filter, setFilter] = useState<'all' | 'high' | 'medium' | 'low'>('all');
  const filteredClients = clients.filter(client => filter === 'all' || client.priority === filter);
  const getClientForecastCount = (clientId: string) => {
    return forecasts.filter(f => f.clientId === clientId).length;
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-319">
      <div className="p-6 border-b border-gray-200" data-id="element-320">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-321">
          Clients ({clients.length})
        </h2>
        {/* Priority Filter */}
        <div className="flex space-x-2 mt-4" data-id="element-322">
          <button onClick={() => setFilter('all')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${filter === 'all' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-323">
            Tous
          </button>
          <button onClick={() => setFilter('high')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${filter === 'high' ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-324">
            Priorité haute
          </button>
          <button onClick={() => setFilter('medium')} className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${filter === 'medium' ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-325">
            Moyenne
          </button>
        </div>
      </div>
      <div className="divide-y divide-gray-200 max-h-[600px] overflow-y-auto" data-id="element-326">
        {filteredClients.map(client => {
        const forecastCount = getClientForecastCount(client.id);
        return <div key={client.id} className="p-4 hover:bg-gray-50 transition-colors cursor-pointer" data-id="element-327">
              <div className="flex items-start justify-between" data-id="element-328">
                <div className="flex-1 min-w-0" data-id="element-329">
                  <h3 className="text-sm font-semibold text-gray-900 truncate" data-id="element-330">
                    {client.name}
                  </h3>
                  <div className="flex items-start space-x-1 mt-1" data-id="element-331">
                    <MapPin className="w-3 h-3 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-332" />
                    <p className="text-xs text-gray-600" data-id="element-333">
                      {client.address.street}
                      <br data-id="element-334" />
                      {client.address.city}, {client.address.postalCode}
                    </p>
                  </div>
                </div>
                <div className={`ml-2 px-2 py-1 rounded-full text-xs font-medium ${client.priority === 'high' ? 'bg-red-100 text-red-700' : client.priority === 'medium' ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-335">
                  {client.priority === 'high' ? 'Haute' : client.priority === 'medium' ? 'Moyenne' : 'Basse'}
                </div>
              </div>
              <div className="mt-3 flex items-center justify-between" data-id="element-336">
                <div className="flex items-center space-x-2" data-id="element-337">
                  <span className="text-xs text-gray-500" data-id="element-338">SLA:</span>
                  <span className="text-xs font-semibold text-gray-900" data-id="element-339">
                    {client.slaHours}h
                  </span>
                </div>
                {forecastCount > 0 && <div className="flex items-center space-x-1 text-xs text-blue-600" data-id="element-340">
                    <AlertCircle className="w-3 h-3" data-id="element-341" />
                    <span data-id="element-342">{forecastCount} prévision(s)</span>
                  </div>}
              </div>
              <div className="mt-2 pt-2 border-t border-gray-100" data-id="element-343">
                <p className="text-xs text-gray-500" data-id="element-344">{client.contact.name}</p>
              </div>
            </div>;
      })}
      </div>
    </div>;
}